var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.499 2.678A3.005 3.005 0 0 0 21.377.556C19.505.055 12 .055 12 .055s-7.505 0-9.377.501A3.008 3.008 0 0 0 .501 2.678C0 4.55 0 8.455 0 8.455s0 3.905.501 5.777a3.005 3.005 0 0 0 2.122 2.122c1.872.501 9.377.501 9.377.501s7.505 0 9.377-.502a3.005 3.005 0 0 0 2.122-2.122C24 12.36 24 8.455 24 8.455s0-3.905-.501-5.777zM9.6 12.055v-7.2l6.235 3.6-6.235 3.6z"}));
}

Youtube.defaultProps = {"viewBox":"0 0 24 16.855","style":{"enableBackground":"new 0 0 24 16.855"},"xmlSpace":"preserve"};

module.exports = Youtube;

Youtube.default = Youtube;
